(function () {
  if (typeof window === 'undefined') return;

  function init() {
    var sticky = document.querySelector('[data-pdp-sticky-atc]');
    if (!sticky) return;

    var atcForm =
      document.querySelector('.product-single__form') ||
      document.querySelector('form[action*="/cart/add"]');
    if (!atcForm) return;

    var realAtcBtn =
      atcForm.querySelector('button[name="add"]') ||
      atcForm.querySelector('button[type="submit"]');
    if (!realAtcBtn) return;

    var trigger = sticky.querySelector('[data-pdp-sticky-atc-trigger]');
    if (trigger) {
      trigger.addEventListener('click', function () {
        realAtcBtn.click();
      });
    }

    // Vis baren, når selve Tilføj til kurv-knappen er uden for skærmen - over eller under,
    // MEN kun når den valgte variant kan købes. Før blev baren kun vist, når knappen var
    // scrollet forbi (top < 0), så på mobil fandtes der ingen købsknap, mens den lå under
    // folden (ux-audit, issue #4). En udsolgt/utilgængelig variant giver en deaktiveret
    // knap, og så er en fastlåst "Udsolgt"-bar kun støj, så den skjules da.
    var buttonInView = false;

    function updateBar() {
      var show = !buttonInView && !realAtcBtn.disabled;
      if (show) {
        sticky.hidden = false;
        requestAnimationFrame(function () {
          sticky.classList.add('is-visible');
        });
      } else {
        sticky.hidden = true;
        sticky.classList.remove('is-visible');
      }
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          buttonInView = entry.isIntersecting;
          updateBar();
        });
      },
      { rootMargin: '0px 0px 0px 0px', threshold: 0 }
    );

    observer.observe(realAtcBtn);

    // Hold pris og knaptekst i takt med den valgte størrelse, da baren nu er synlig
    // allerede før kunden har valgt. Temaet sender variant:change med den valgte variant
    // (variant er udefineret for en kombination, der ikke findes).
    // Samme format som Liquid-udgaven (money_without_trailing_zeros): "249 kr", ikke "249,00 kr".
    function formatMoney(cents) {
      var formatted;
      if (window.theme && window.theme.Currency && window.theme.settings) {
        formatted = window.theme.Currency.formatMoney(cents, window.theme.settings.moneyFormat);
      } else {
        formatted = (cents / 100).toFixed(2).replace('.', ',') + ' kr';
      }
      return formatted.replace(/,00(?!\d)/, '');
    }

    // variant:change sendes for ALLE variantvælgere på siden (fx "Ofte købt sammen med"),
    // så baren må kun reagere på hovedproduktets egne varianter.
    var ownVariantIds = (sticky.dataset.variantIds || '').split(',');

    function addSpan(parent, className, text) {
      var span = document.createElement('span');
      span.className = className;
      span.textContent = text;
      parent.appendChild(span);
    }

    document.addEventListener('variant:change', function (evt) {
      var variant = evt && evt.detail && evt.detail.variant;

      // Ignorer ændringer fra andre produkter på siden. En manglende variant (kombination
      // der ikke findes) kan ikke afgøres og læses via knappens tilstand nedenfor.
      if (variant && ownVariantIds.indexOf(String(variant.id)) === -1) return;

      if (variant) {
        var price = sticky.querySelector('.pdp-sticky-atc__price');
        if (price) {
          price.textContent = '';
          addSpan(price, 'pdp-sticky-atc__price-now', formatMoney(variant.price));
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            price.appendChild(document.createTextNode(' '));
            addSpan(price, 'pdp-sticky-atc__price-was', formatMoney(variant.compare_at_price));
          }
        }

        if (trigger) {
          var label = variant.available ? trigger.dataset.labelAdd : trigger.dataset.labelSoldOut;
          if (label) trigger.textContent = label;
        }
      }

      // Temaets egen variantChange-håndtering har allerede sat den rigtige knaps tilstand
      // (også for en ikke-eksisterende kombination); læs den igen, når den er færdig.
      setTimeout(updateBar, 0);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
